<template>
  <div>
    <textarea class="form-control" :value="value" @input="$emit('input',$event.target.value)" :rows="rows" :placeholder="placeholder"></textarea>
  </div>
</template>

<script>
  export default{
    props: {
      rows: {
        type: String,
        requiered: false
      },
      placeholder: {
        type: String,
        requiered: false
      },
      value: {
        type: String,
        requiered: false
      }
    }
  }
</script>

<style>    
    
</style>



// WEBPACK FOOTER //
// regularTextarea.vue?a2183514